import { Switch } from 'antd';
import { graphicPackingUseMutation } from '../hooks/index';

const GraphicPackingRadioField = ({ id, status }) => {

    const {
        _setGraphicPackingCreateUpdate,
    } = graphicPackingUseMutation.createUpdate(id, false);

    return (
        <Switch
            checked={ status }
            onChange={
                (checked) => {
                    _setGraphicPackingCreateUpdate({
                        variables: {
                            input: {
                                id,
                                status: checked
                            }
                        }
                    })
                }
            } />
    );
};

export default GraphicPackingRadioField;
